import { Helmet } from "react-helmet-async";

const CANONICAL_BASE = "https://linguasub.in";

/**
 * Reusable per-page SEO tags. Pass `path` (starts with '/') to build a canonical.
 * Falls back to the site-wide description if none is provided.
 */
export default function Seo({ title, description, path = "/", noindex = false }) {
  const canonical = `${CANONICAL_BASE}${path}`;
  const desc = description || "AI-powered subtitle localization that preserves slang, humour, emotion, character personality and cultural meaning across 21 languages.";
  const fullTitle = title ? `${title} · LinguaSub` : "LinguaSub — AI subtitles that preserve slang, humour and soul";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
